export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7028a8ba53b61fa82ab15e61453ddab6742c0178db&name=pushAdClickData!'